import mutations from '../news/mutations'
import actions from '../news/actions'

const news = {
    namespaced: true,
    state: {
        news: [],
        feed: null,
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            fromDate: null,
            toDate: null,
            header: null,
            showTo: null
        }
    },
    mutations,
    actions
}

export default news
